import DepartureUnloadingData from './DepartureUnloadingData';

export default DepartureUnloadingData;
